// extracted by mini-css-extract-plugin
export default {"mobileSecondaryNav":"mobileSecondaryNav__SqsxD","mobileSecondaryNavItem":"mobileSecondaryNavItem__ukqQN","active":"active__NPkp1"};